<template>
  <div class="mb-5">
    <div class="b-form__container_type_flex">
      <checkbox class="b-checkbox" v-model="form.isBuyout" @change="changeBuyoutState">{{$t('CONTENT.assets.buyout')}}</checkbox>
      <dynamic-icon class="ml-1" v-tooltip="$t('CONTENT.hints.buyoutEvent')" icon="question"></dynamic-icon>
    </div>
    <transition name="fade" v-if="form.isBuyout">
      <div class="my-5 ml-6">
        <h5 class="mb-2">{{$t('CONTENT.assets.options_spi')}}</h5>
        <div class="b-form__container_type_flex">
          <checkbox class="b-checkbox" v-model="buyoutIsSure">{{$t('CONTENT.assets.options_is_buyout')}}</checkbox>
          <dynamic-icon class="ml-1" v-tooltip="$t('CONTENT.hints.buyoutEventIsSure')" icon="question"></dynamic-icon>
        </div>
        <div class="row mt-5 px-0">
          <div class="col-4">
            <div class="b-form__container">
              <label>{{$t('CONTENT.assets.option_month_count')}}:</label>
              <numeric
                class="b-numeric"
                controls
                :min="0"
                v-model="buyoutMonthCount"
                :disabled="!form.isSure || isReadOnlyField"
                @keypress="changeNumericValue($event)"
                @change="onChangeBuyoutMonthCount"
              ></numeric>
            </div>
          </div>
          <div class="col-4">
            <div class="b-form__container">
              <label>{{$t('CONTENT.assets.option_buyout_date')}}:</label>
              <div class="is-manually">
                <div
                  v-if="isManuallyBuyoutDate"
                  class="is-manually-mark"
                  :title="`${$t('CONTENT.isManuallyData')}`"
                ></div>
                <datepicker
                  class="b-datepicker"
                  v-model="buyoutDate"
                  :disabled="!form.isSure || isReadOnlyField"
                  :formatter="datepickerFormat"
                  @change="manualBuyoutDateChange"
                ></datepicker>
              </div>
            </div>
          </div>
        </div>
        <!--Данные платежа по выкупу-->
        <div v-if="form.isSure">
          <div class="row mt-5">
            <div class="col-4">
              <div>
                <label>{{$t('CONTENT.payments.payment_currency_code')}}:</label>
                <cool-select
                  :list="currencyCodes"
                  option-value="code"
                  option-text="name"
                  :placeholder="$t('CONTENT.choose')"
                  v-model="currencyCode"
                ></cool-select>
              </div>
            </div>
            <div class="col-4">
              <div class="b-form__container">
                <label for="buyout-external-id">{{$t('CONTENT.external_id')}}:</label>
                <input
                  type="text"
                  id="buyout-external-id"
                  class="b-input"
                  name="buyout-external-id"
                  v-model.lazy="form.externalId"
                />
              </div>
            </div>
          </div>
          <div class="mt-5">
            <div class="row mt-2 b-form__container_type_flex b-form__row_type_flex-end">
              <div class="col-4" data-cy="buyout-lease-rate">
                <label>{{$t('CONTENT.assets.redemption_value')}}:</label>
                <numeric class="b-numeric" controls :min="0" :max="1000000000000" v-model="form.rate"></numeric>
              </div>
              <div class="col-4">
                <div>
                  <label>{{$t('CONTENT.payments.payment_date')}}:</label>
                  <datepicker class="b-datepicker" v-model="paymentDate" :formatter="datepickerFormat"></datepicker>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import dateConverter from "@/utils/converters/date.converter";
import DateWithoutTimeAPI from "@/api/DateWithoutTimeAPI";
import changeNumericValue from "@/mixins/changeNumericValue";
import datepickerFormat from '@/mixins/datepickerFormat.mixin';

export default {
  props: {
    assetComponent: {
      type: Object
    },
    form: {
      required: true,
      type: Object
    },
    currencyCodes: {
      type: Array,
      required: true
    }
  },
  created() {
    if(this.form.paymentDate != null) {
      this.buyoutPaymentDate = this.form.paymentDate;
    }
  },
  data() {
    return {
      buyoutMonthCount: null,
      isManuallyBuyoutDate: false,
      isReadOnlyField: false,
      buyoutCurrencyCode: null,
      buyoutPaymentDate: null,
    };
  },
  mixins: [changeNumericValue, datepickerFormat],
  watch: {
    'form.isBuyout'(val) {
      if(!val) {
        this.form.isSure = false;
        this.resetBuyout();
      }
    }
  },
  computed: {
    buyoutDate: {
      get() {
        if (this.form.date !== null) {
          return dateConverter.convertToDate(this.form.date);
        } else {
          return null;
        }
      },
      set(newVal) {
        if (newVal !== null) {
          this.form.date = dateConverter.convertToString(newVal);
        } else {
          this.form.date = null;
        }
      }
    },
    buyoutIsSure: {
      get() {
        return this.form.isSure;
      },
      set(value) {
        this.form.isSure = value;

        if(!value) {
          this.resetBuyout();
        }
      }
    },
    currencyCode: {
      get() {
        if(this.form.currencyCode) {
          return this.form.currencyCode.toLowerCase();
        } else {
          return this.buyoutCurrencyCode;
        }
      },
      set(newVal) {
        this.buyoutCurrencyCode = newVal.toUpperCase();
        this.form.currencyCode = newVal.toUpperCase();
      }
    },
    paymentDate: {
      get() {
        if (this.buyoutPaymentDate !== null) {
          return dateConverter.convertToDate(this.buyoutPaymentDate);
        } else {
          return this.buyoutPaymentDate;
        }
      },
      set(newVal) {
        if (newVal !== null) {
          this.buyoutPaymentDate = dateConverter.convertToString(newVal);
          this.form.paymentDate = dateConverter.convertToString(newVal);
        } else {
          this.buyoutPaymentDate = null;
          this.form.paymentDate = null;
        }
      }
    }
  },
  methods: {
    manualBuyoutDateChange(newVal) {
      if (newVal == null) {
        this.isManuallyBuyoutDate = false;
        this.buyoutMonthCount = 0;
        return;
      }

      this.isManuallyBuyoutDate = true;
      this.buyoutMonthCount = 0;
      this.form.date = dateConverter.convertToString(newVal);
    },
    async onChangeBuyoutMonthCount(newVal) {
      if (newVal !== 0) {
        this.isManuallyBuyoutDate = false;
        this.isReadOnlyField = true;

        if (this.assetComponent.startDate != null && this.assetComponent.startDate !== "") {
          const convertedCurrentAssetComponentStartDate = encodeURIComponent(this.assetComponent.startDate);
          let newDate = await new DateWithoutTimeAPI().addMonths(convertedCurrentAssetComponentStartDate, newVal);
          this.updateBuyoutDate(newDate);
        }
        this.isReadOnlyField = false;
      }
    },
    updateBuyoutDate(value) {
      this.buyoutDate = dateConverter.convertToDate(value);
      this.form.date = value;
    },
    changeBuyoutState(e) {
      this.form.isBuyout = e;
    },
    resetBuyout() {
      this.buyoutDate = null;
      this.buyoutPaymentDate = null;
      this.buyoutMonthCount = null;
      this.form.currencyCode = null;
      this.form.date = null;
      this.form.externalId = null;
      this.form.paymentDate = null;
      this.form.rate = null;
    }
  }
};
</script>
